import React, { useEffect } from 'react';
import {
    Box,
    Grid,
    IconButton,
    FormControlLabel,
    Checkbox,
    InputAdornment,
    Paper,
    Autocomplete,
    Typography,
    TextField,

} from '@mui/material';
import { useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import CustomButton from '../../components/Buttons';
import DownloadIcon from '@mui/icons-material/Download';
import HeaderComponent from '../../components/Header';
import CustomCard from '../../components/UIComponents/CustomCard';
import resetFilter from "../../assets/image/resetfilter.png"
import BasicTable from "../../components/Table/index"
import TableData from './table';
// import ReservationQuickPopup from './Popup';
import { createMaintenance, fetchIssueCategory, fetchMaintenanceList, fetchReservationList, fetchRoomList, fetchRoomTypes, updateMaintenance } from '../../service/network';
import StyledAutocomplete from '../../components/UIComponents/StyledAutocomplete';
import theme from '../../assets/theme';
import { useLoading } from '../../context/loading.context';
import StyledTextField from '../../components/UIComponents/StyledTextField';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import AddMaintenancePopup from './Popups/AddMaintenancePopup';
import moment from 'moment/moment';
import { useNotification } from "../../context/notification.context";
import * as XLSX from 'xlsx';
import CommonTable from '../../components/Table/CommonTable';
import { ContentCutOutlined, Upload } from '@mui/icons-material';

export default function MaintenanceList() {
    const statusList = ['Completed', 'Pending', "Canceled"]
    const priorityOptions = ['Low', 'Medium', 'High'];
    const reportedbyOptions = ['Guest', "Employee"]

    const [filters, setFilters] = useState({
        fromDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        issue_category: '',
        priority: '',
        status: '',
        reported_by: '',
        room_name: ''
    });

    const { formReservationListRows, ReservationListHeader } = TableData();
    // const [roomTypeOptions, setRoomTypeOptions] = useState([]);
    const { showLoader, hideLoader } = useLoading();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [addopenPopup, setAddOpenPopup] = useState(false);
    const [editOpenPopup, setEditOpenPopup] = useState(false);
    const [viewOpenPopup, setViewOpenPopup] = useState(false);
    const [maintenanceList, setMaintenanceList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [dialogMode, setDialogMode] = useState('add');
    const { showNotification } = useNotification();
    const [selectrowId, setSelectrowId] = useState(null);
    const [rooms, setRooms] = useState([])


    const [formData, setFormData] = useState({
        room_no: '',
        issue_category: '',
        reported_by: '',
        priority: '',
        description: '',
        date_time: ''
    });

    const handleFilterChange = (name, value) => {
        console.log("filters", filters);
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const exportToExcel = () => {
        if (!maintenanceList || maintenanceList.length === 0) {
            alert("No data available to export.");
            return;
        }

        // ✅ Transform using table logic
        const rows = formReservationListRows(maintenanceList); // this gives table-formatted rows
        console.log("formReservationListRows", rows)

        // 🔄 Map and clean for Excel export (remove JSX elements like status badge)
        const exportData = rows.map((row) => ({
            Request_ID: row.request_id,
            Room_No: row.room_no,
            Issue_Category: row.issue_category,
            Priority: row.priority,
            Status: row.details?.status || '', // ⛔ status is JSX component, handle accordingly
            Reported_By: row.reported_by,
            Reported_Time: row.details?.reported_time || '', // ⛔ handle <HighlightedCell>
            Resolved_time: row.resolved_time ? row.resolved_time : '',
            Resolution_Time: row.resolutionTime,
        }));

        // Convert to worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // Optional: Set column widths
        worksheet['!cols'] = [
            { wch: 15 },
            { wch: 12 },
            { wch: 20 },
            { wch: 10 },
            { wch: 15 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
        ];

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Maintenance");

        // Save
        XLSX.writeFile(workbook, "maintenance_data.xlsx");
    };


    const handleAddClick = () => {
        setFormData({
            room_no: '',
            issue_category: '',
            reported_by: '',
            priority: '',
            description: '',
            date_time: '',
            reported_time: '',
        });
        setAddOpenPopup(true);
        setDialogMode("add");
    };

    const handleEditClick = (rowData) => {
        setFormData({
            id: rowData.request_id,
            room_no: rowData.room_no,
            issue_category: rowData.details.issue_category_name,
            reported_by: rowData.reported_by,
            priority: rowData.priority,
            description: rowData.description || '',
            date_time: rowData.details.reported_time || '',
            resolved_time: '',
        });
        setEditOpenPopup(true);
        setDialogMode("edit");
    };


    const handleViewClick = (rowData) => {
        setFormData({
            id: rowData.request_id,
            room_no: rowData.room_no,
            issue_category: rowData.details.issue_category_name,
            reported_by: rowData.reported_by,
            priority: rowData.priority,
            description: rowData.description || '',
            date_time: rowData.details.reported_time || '',
            status: rowData.details?.status || '',
            resolved_time: rowData.resolved_time
        });
        setViewOpenPopup(true);
        setDialogMode("view");
    };

    const fetchRooms = async () => {
        try {
            showLoader()
            const roomListParams = {
                doctype: 'Room',
                fields: JSON.stringify(["room_name", "type", "status", "info", "name"]),
                // filters: JSON.stringify({ company: "Mathiro Bliss" }),
            };

            const response = await fetchRoomList(roomListParams);

            const { keys, values } = response.data.message;
            const roomData = values.map(row =>
                keys.reduce((acc, key, i) => {
                    acc[key] = row[i];
                    return acc;
                }, {})
            );
            console.log("roomData", roomData)

            setRooms(roomData);
        } catch (err) {
            console.error("Failed to fetch initial data", err);
        } finally {
            hideLoader()
        }
    };

    const fetchIssueCategories = async () => {
        try {
            showLoader();
            const categoryParams = {
                doctype: 'Issue Category',
                fields: JSON.stringify(["name", "category_name"])
            };
            const categoryTypeRes = await fetchIssueCategory(categoryParams);
            const { keys, values } = categoryTypeRes.data.message;
            const formattedCategoryData = values.map(row =>
                keys.reduce((acc, key, i) => {
                    acc[key] = row[i];
                    return acc;
                }, {})
            );
            setCategoryList(formattedCategoryData);
            console.log("formattedCategoryData", formattedCategoryData);
        } catch (err) {
            console.error("Failed to fetch initial data", err);
        } finally {
            hideLoader();
            showLoader(false);
        }
    };

    const createMaintenanceDetails = async (data) => {
        try {
            showLoader();

            const payload = {
                doc: JSON.stringify({
                    doctype: "Room Maintenance",
                    room: data.room_no.name || '',
                    issue_category: data.issue_category?.name,
                    reported_by: data.reported_by,
                    priority: data.priority,
                    description: data.description,
                    status: data.status || "Pending",
                    reported_time: data?.reported_time || ""
                }),
                action: "Save"

            };
            console.log("payload", payload)
            const response = await createMaintenance(payload);
            if (!response?.data) {
                throw new Error("Invalid response structure");
            }
            showNotification("success", "Success", "Successfully Created");
            console.log("API response:", response.data);
            setAddOpenPopup(false);
            fetchMaintenance()

        } catch (error) {
            showNotification("error", "Error", "Failed to update maintainance");
            console.error("Failed to fetch data:", error);
        } finally {
            hideLoader();
        }
    };

    const updateMaintenanceDetails = async (data) => {
        try {
            showLoader();

            const payload = {
                doctype: "Room Maintenance",
                issue_category: data.issue_category?.name,
                reported_by: data.reported_by,
                priority: data.priority,
                description: data.description,
                status: data.status,
                resolved_time: data?.resolved_time || ''
            }

            const response = await updateMaintenance(selectrowId, payload);
            if (!response?.data) {
                throw new Error("Invalid response structure");
            }
            showNotification("success", "Updated", "Successfully Updated");
            console.log("API response:", response.data);
            setEditOpenPopup(false);
            fetchMaintenance()

        } catch (error) {
            showNotification("error", "Error", "Failed to update maintainance");
            console.error("Failed to fetch  data:", error);
        } finally {
            hideLoader();
        }
    };

    const resetFilters = () => {
        setFilters({
            fromDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            issue_category: '',
            priority: '',
            status: '',
            reported_by: '',
            room_name: ''
        });
    };

    useEffect(() => {
        fetchRooms();
        fetchIssueCategories();
    }, []);

    useEffect(() => {
        if (categoryList.length > 0) {
            fetchMaintenance(); // only run after categoryList is ready
        }
    }, [categoryList, filters]); // ✅ dependency added here

    const fetchMaintenance = async () => {
        try {
            showLoader();
            // Fetch package data
            const filterConditions = [];

            if (filters.fromDate) {
                filterConditions.push(['reported_time', '>=', moment(filters.fromDate).startOf('day').format("YYYY-MM-DD HH:mm:ss ")]);
            }

            if (filters.toDate) {
                filterConditions.push(['reported_time', '<=', moment(filters.toDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")]);
            }

            if (filters.issue_category) {
                filterConditions.push(['issue_category', '=', filters.issue_category?.name]);
            }

            if (filters.priority) {
                filterConditions.push(['priority', '=', filters.priority]);
            }
            if (filters.status) {
                filterConditions.push(['status', '=', filters.status]);
            }
            if (filters.reported_by) {
                filterConditions.push(['reported_by', '=', filters.reported_by]);
            }
            if (filters.room_name) {
                filterConditions.push(['room', '=', filters.room_name?.name]);
            }
            const maintenanceParams = {
                doctype: 'Room Maintenance',
                fields: JSON.stringify(["name", "room", "room.room_name", "issue_category", "priority", "reported_by", "reported_time", "resolved_time", "status", "description"]),
                ...(filterConditions.length > 0 && { filters: JSON.stringify(filterConditions) }),
            };
            const response = await fetchMaintenanceList(maintenanceParams);
            console.log("Api Response", response.data.message);


            const { keys, values } = response.data.message;
            if (values.length > 0) {
                const formattedData = values.map(row =>
                    keys.reduce((acc, key, i) => {
                        acc[key] = row[i];
                        return acc;
                    }, {})
                );
                console.log("Formatted Maintenance Data:", formattedData);

                const maintenance = formattedData.map(obj => {
                    const matchedcategory = categoryList.find(cat => cat.name === obj.issue_category);

                    return {
                        ...obj,
                        issue_category_name: matchedcategory || "unkown"
                    }
                })
                console.log("maintenanceList", maintenance);
                setMaintenanceList(maintenance);
            }
            else {
                setMaintenanceList([])
            }

        } catch (error) {
            console.error("Failed to fetch Maintenance", errorMessage);
            showNotification('error', 'Error', errorMessage);
        } finally {
            hideLoader();
        }
    };

    const saveMaintenanceEntry = async (data) => {
        try {
            showLoader();
            if (dialogMode === "add") {
                console.log("Creating Maintenance Entry:", data);
                await createMaintenanceDetails(data);
            } else {
                console.log("updating Maintenance Entry:", data);
                await updateMaintenanceDetails(data)
            }
        } catch (err) {
            console.error("Failed to save maintenance entry", err);
        } finally {
            setSelectrowId(null);
            hideLoader();
        }
    };


    return (
        <Box sx={{ width: '100%', p: 2 }}>
            <HeaderComponent title="Maintenance List" />
            <AddMaintenancePopup
                open={addopenPopup}
                onClose={() => setAddOpenPopup(false)}
                onSave={(data) => {
                    console.log("Saved Maintenance Data:", data);
                    saveMaintenanceEntry(data);

                }}
                formData={formData}
                setFormData={setFormData}
                issueCategories={categoryList}
                reportedByOptions={['Guest', "Employee"]}
                priorityOptions={['Low', 'Medium', 'High']}
                roomsOptions={rooms}
                mode="add"
            />
            <AddMaintenancePopup
                open={editOpenPopup}
                onClose={() => setEditOpenPopup(false)}
                onSave={(data) => {
                    saveMaintenanceEntry(data);

                }}
                formData={formData}
                setFormData={setFormData}
                issueCategories={categoryList}
                reportedByOptions={['Guest', "Employee"]}
                priorityOptions={['Low', 'Medium', 'High']}
                roomsOptions={rooms}
                mode="edit"
            />
            <AddMaintenancePopup
                open={viewOpenPopup}
                onClose={() => setViewOpenPopup(false)}
                formData={formData}
                setFormData={setFormData}
                issueCategories={categoryList}
                reportedByOptions={['Guest', "Employee"]}
                priorityOptions={['Low', 'Medium', 'High']}
                roomsOptions={rooms}
                mode="view"
            />

            <CustomCard
                bgColor="light"
                shadow="lg"
                borderRadius="xxl"
                sx={{
                    width: '100%',
                    minHeight: 800,
                    borderTopLeftRadius: 0,
                }}
            >
                <Grid container spacing={2} justifyContent="flex-end">
                    {/* Action Buttons */}
                    <Grid item xs={12} md={6}  >
                        <Box display='flex' gap={1}>
                            <IconButton
                                color="primary"
                                sx={{
                                    border: '2px solid #27394D',
                                    borderRadius: '6px',
                                    p: '4px',
                                    minWidth:39,
                                    height: 39,
                                    flexShrink: 0,
                                    mt:0.2,
                                    borderRadius:"8px"
                                }}
                                onClick={fetchIssueCategories}
                            >
                                <AutorenewOutlinedIcon fontSize="small" /> 
                            </IconButton>


                            <CustomButton
                                variant="outlined"
                                startIcon={<Upload />}
                                sx={{
                                    borderColor: 'primary.main',
                                    hegiht: 36,
                                    color: 'primary.main',
                                    borderRadius: theme.borderRadius.medium,
                                    border: "2px solid var(--Primary-Blue-MB, #27394D)",
                                    textTransform: 'none',
                                    '&:hover': { borderColor: 'primary.dark' },
                                }}
                                onClick={exportToExcel}
                            >
                                Export
                            </CustomButton>
                            <CustomButton
                                variant="outlined"
                                startIcon={<AddIcon />}
                                onClick={handleAddClick}
                                sx={{
                                    color: 'light.main',
                                    borderRadius: theme.borderRadius.medium,
                                    backgroundColor: 'primary.main',
                                    textTransform: 'none',
                                    '&:hover': { borderColor: 'primary.dark' },
                                }}
                            >
                                Add New Maintenance
                            </CustomButton>
                        </Box>
                    </Grid>
                </Grid>

                <Grid container spacing={0.5} mt={3}>
                    <Grid item size={{ xs: 6, md: 1.4 }}>
                        <StyledTextField
                            value={filters.fromDate}
                            label="From Date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                            inputProps={{
                                max: filters.toDate
                            }}
                        />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 1.4 }}>
                        <StyledTextField
                            value={filters.toDate}
                            label="To Date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleFilterChange('toDate', e.target.value)}
                            inputProps={{
                                min: filters.fromDate
                            }}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 1.8 }}>
                        <StyledAutocomplete
                            label="Room No."
                            options={rooms}
                            value={filters.room_name}
                            onChange={(e, newValue) => handleFilterChange('room_name', newValue)}
                            getOptionLabel={(option) => option.room_name || ""}
                            componentsProps={{
                                paper: {
                                    sx: {
                                        borderRadius: '8px',
                                        backgroundColor: 'lightred.main',
                                        '& .MuiAutocomplete-option:hover': {
                                            backgroundColor: '#FFD4D1',
                                        },
                                    },
                                },
                            }}
                        />


                    </Grid>
                    <Grid item size={{ xs: 12, md: 1.8 }}>
                        <StyledAutocomplete
                            label="Issue Category"
                            options={categoryList}
                            value={filters.issue_category}
                            onChange={(e, newValue) => handleFilterChange('issue_category', newValue)}
                            getOptionLabel={(option) => option.category_name || ""}
                            componentsProps={{
                                paper: {
                                    sx: {
                                        borderRadius: '8px',
                                        backgroundColor: 'lightred.main',
                                        '& .MuiAutocomplete-option:hover': {
                                            backgroundColor: '#FFD4D1',
                                        },
                                    },
                                },
                            }}
                        />

                    </Grid>
                    <Grid item size={{ xs: 12, md: 1.8 }}>
                        <StyledAutocomplete
                            label="Priority"
                            options={priorityOptions}
                            value={filters.priority}
                            onChange={(e, newValue) => handleFilterChange('priority', newValue)}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 1.4 }}>
                        <StyledAutocomplete
                            label="Status"
                            options={statusList}
                            value={filters.status}
                            onChange={(e, newValue) => handleFilterChange('status', newValue)}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 1.8 }}>
                        <StyledAutocomplete
                            label="Reported By"
                            options={reportedbyOptions}
                            value={filters.reported_by}
                            onChange={(e, newValue) => handleFilterChange('reported_by', newValue)}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 0.6 }} justifyContent="flex-end">
                        <Box mt={2.5} display="flex"
                            justifyContent="flex-end">
                            <IconButton
                                color="primary"
                                sx={{
                                    border: '2px solid #27394D',
                                            borderRadius: '8px',
                                    p:"6px",
                                    minWidth:36,
                                    minHeight:36,
                                    mt:0.5

                                }}
                                onClick={resetFilters}
                            >
                                <img src={resetFilter} width={22} height={22} />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3, width: "100%" }}>
                    <CommonTable
                        backgroundColor={'light.main'}
                        disableElevation={true}
                        data={{
                            rows: ReservationListHeader,
                            columns: formReservationListRows(maintenanceList),
                        }}
                        onRowClick={(rowData) => {
                            console.log("clickrow", rowData)
                            setSelectrowId(rowData.request_id);
                            if (rowData.details.status === "Completed" || rowData.details.status === "Canceled") {
                                handleViewClick(rowData);
                            } else {
                                handleEditClick(rowData);
                            }
                        }}
                    />
                </Box>

            </CustomCard>
        </Box >
    );
}